import { Card, Container } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { ReactComponent as Logo } from "../../assets/img/logo.svg";

import "./style.css";

interface Props {
    children: React.ReactNode;
}

const ConnexionLayout: FC<Props> = ({ children }) => {
    const navigate = useNavigate();

    return (
        <div className="connexion_background">
            <Container className="connexion_container">
                <div
                    onClick={() => navigate("/login")}
                    className="connexion_logo_container"
                >
                    <Logo className="connexion_logo" />
                </div>
                <div>
                    <p className="connexion_title">
                        MON JOURNAL DE <b>TRADING</b>
                    </p>
                    <div className="connexion_divider" />
                    <Card className="connexion_card">{children}</Card>
                </div>
                <div className="connexion_bottom_links">
                    <a
                        href="https://www.objectif-trading.fr/mentions-legales"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Mentions Légales
                    </a>
                    <p>•</p>
                    <a
                        href="https://www.objectif-trading.fr/cgu"
                        target="_blank"
                        rel="noreferrer"
                    >
                        CGU
                    </a>
                    <p>•</p>
                    <a
                        href="https://www.objectif-trading.fr/cgv"
                        target="_blank"
                        rel="noreferrer"
                    >
                        CGV
                    </a>
                    <p>•</p>
                    <a
                        href="https://www.objectif-trading.fr/contact"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Contact
                    </a>
                    <p>•</p>
                    <a
                        href="https://www.objectif-trading.fr/mentions-legales#confidentialite"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Politique de confidentialité
                    </a>
                </div>
            </Container>
        </div>
    );
};

export default ConnexionLayout;
